// Response-related types

export enum RiskAssessmentResult {
  Green = "Green",
  Amber = "Amber",
  Red = "Red",
}

export enum ClaimType {
  Motor = "Motor",
  NotSpecified = "NOT SPECIFIED",
  Unknown = "UNKNOWN",
}

export interface RiskIncident {
  id: number;
  claimType: ClaimType;
  incidentDate: string;
  matchIndividual: boolean;
  matchAliasOrID: boolean;
  matchDrivingLicenseNumber: boolean;
  matchNationalInsuranceNumber: boolean;
  matchPassportNumber: boolean;
  matchPhoneNumber: boolean;
  matchEmailAddress: boolean;
  matchAddress: boolean;
  matchOrganisation: boolean;
  matchVehicle: boolean;
}

export interface RiskSearchResult {
  id: string;
  result: RiskAssessmentResult;
  ruleBreaks: string[];
  incidents: RiskIncident[];
}
